import { api } from './api';

// Generic region catalog + region-based platform fee rules.
// See platform_fee_regions.md.
export const regionsService = {
    listRegions: () => api.get('/api/admin/regions'),
    listStates: () => api.get('/api/admin/regions/states'),
    createRegion: (body) => api.post('/api/admin/regions', body),
    updateRegion: (id, body) => api.put(`/api/admin/regions/${id}`, body),
    deleteRegion: (id) => api.delete(`/api/admin/regions/${id}`),

    listFeeRates: (regionId) =>
        api.get(`/api/admin/platform-fee/rates${regionId ? `?region_id=${regionId}` : ''}`),
    createFeeRate: (body) => api.post('/api/admin/platform-fee/rates', body),
    updateFeeRate: (id, body) => api.put(`/api/admin/platform-fee/rates/${id}`, body),
    deleteFeeRate: (id) => api.delete(`/api/admin/platform-fee/rates/${id}`),
};
